import { pipe, split, dropLast, join, replace } from "ramda";

const removeTrailingPath = pipe(
  replace(/\/+$/, ""), // remove trailing forward slashes
  split("/"),
  dropLast(1),
  join("/")
);
const sweepstakesUrl = () => `${window.location.origin}${removeTrailingPath(window.location.pathname)}`;
const redirectParams = ({ donationId, promoCodeName, paymentMethod }) => {
  const promoParam = promoCodeName ? `&promo=${promoCodeName}` : "";

  return `?donationId=${donationId}&paymentMethod=${paymentMethod}${promoParam}`;
}

export const buildRedirectUrl = ({ donationId, promoCodeName, paymentMethod }) => {
  return `${sweepstakesUrl()}/donate/receipt${redirectParams({ donationId, promoCodeName, paymentMethod })}`;
}
